import { makeStyles, createStyles } from '@material-ui/core/styles';

const brandStyles = {
  forreston: {
    logo: {
      height: 22.5,
      width: 250
    }
  },
  oakwood: {
    logo: {
      height: 33
    }
  }
};

export default makeStyles((theme) =>
  createStyles({
    widget: {
      width: 480,
      padding: 48,
      height: 'auto',
      margin: 'auto',
      background: theme.colorPalette.white_30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 6,
      boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.10)',
      '& h1': {
        alignSelf: 'start',
        margin: '32px 0px 0px 0px',
        fontSize: 40,
        fontWeight: 300,
        color: theme.colorPalette.green_75
      },
      '& h3': {
        alignSelf: 'start',
        fontSize: 16,
        fontWeight: 400,
        color: theme.colorPalette.green_75,
        margin: 0
      }
    },
    logo: ({ brandName }) => ({
      alignSelf: 'start',
      height: 33,
      ...(brandStyles[brandName]?.logo || {})
    }),
    form: {
      marginTop: 24,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      '& input': {
        padding: 8,
        color: theme.colorPalette.green_75,
        border: 'none',
        width: '100%',
        height: 36,
        marginBottom: 16,
        '&::placeholder': {
          color: theme.colorPalette.green_75,
          opacity: 0.5
        }
      },
      '& label': {
        fontSize: 12,
        fontWeight: 400,
        color: theme.colorPalette.green_75,
        marginBottom: 4
      },
      '& button': {
        background: theme.colorPalette.green_30,
        color: '#FFF',
        width: '100%',
        height: 36,
        borderRadius: 4,
        fontSize: 16,
        fontWeight: 600,
        transition: 'all 0.2s ease-out',
        '&:hover': {
          cursor: 'pointer',
          opacity: 0.8
        }
      }
    },
    error: {
      color: theme.colorPalette.red_20,
      marginTop: '24px !important',
      padding: 0
    },
    footer: {
      fontSize: 14,
      marginTop: 24,
      textAlign: 'center',
      '& span': {
        fontWeight: 600,
        color: theme.colorPalette.green_75
      },
      '& p': {
        fontWeight: 400,
        margin: 0
      }
    }
  })
);
